// FILECONTENT_START src/common/bootstrap.ts
import i18n from "i18n-js";
import moment from "moment-timezone";
import Settings from "./interfaces/Settings";

/**
 * override in bootstrap method by project configuration
 */
export let appSettings: Settings = {
  apiHost: process.env.REACT_APP_API_HOST,
  requestTimeout: 15000,
  loginUrl: "/auth/login",
  refreshTokenUrl: "/auth/refresh",
  logoutUrl: "/auth/logout",
  refreshTokenDeltaTime: 35,
  refreshTokenNotificationDeltaTime: 20,
  i18n: {
    fallbacks: true,
    locale: "en",
    defaultLocale: "en",
    translations: {},
    moment: {
      week: {
        dow: 1, // Monday is the first day of the week.
      },
    },
  },
};

/**
 * Configure app via settings.
 * @param settings
 */
export default function bootstrap(settings: Settings) {
  appSettings = settings;
  moment.updateLocale(settings.i18n.locale, settings.i18n.moment || null);
  i18n.fallbacks = settings.i18n.fallbacks;
  i18n.defaultLocale = settings.i18n.defaultLocale;
  i18n.translations = settings.i18n.translations;
  i18n.locale = settings.i18n.locale;
}

// FILECONTENT_END src/common/bootstrap.ts